import React from 'react';
import { BottomBase, Container } from './styled';
function Bottom(_a) {
    var children = _a.children;
    return (React.createElement(BottomBase, null,
        React.createElement(Container, null, children)));
}
export default Bottom;
